export default {
  'pages.covenantDevice.mac': 'MAC-адрес',
  'pages.admin.providerCard.config.grpcAddr': 'gRPC-адрес',
  'pages.covenantDevice.cardTitle': 'Управление контрактными устройствами',
  'pages.admin.whitelist.mac': 'MAC-адрес',
  'pages.covenantDevice.operations': 'Операции',
  'pages.covenantDevice.expireTime': 'Время истечения',
  'pages.covenantDevice.updateTime': 'Время обновления',
  'pages.unbindDevice.titleAdmin': 'Отвязать устройство (требуется администратор)',
  'pages.unbindDevice.inputPlaceholder': 'Пожалуйста, введите ID устройства',
  'pages.unbindDevice.unbind': 'Отвязать',
  'pages.unbindDevice.unbinding': 'Отвязка...',
  'pages.unbindDevice.success': 'Отвязка успешна',
  'pages.unbindDevice.fail': 'Отвязка не удалась',
  'pages.layouts.userLayout.title': 'Консоль управления',
  'pages.login.accountLogin.tab': 'Вход в аккаунт',
  'pages.login.accountLogin.errorMessage':
    'Неправильное имя пользователя/пароль(admin/ant.design)',
  'pages.login.failure': 'Вход не удался, попробуйте еще раз!',
  'pages.login.success': 'Вход выполнен успешно!',
  'pages.login.username.placeholder': 'Имя пользователя: admin или user',
  'pages.login.username.required': 'Пожалуйста, введите ваше имя пользователя!',
  'pages.login.password.placeholder': 'Пароль: ant.design',
  'pages.login.password.required': 'Пожалуйста, введите ваш пароль!',
  'pages.login.phoneLogin.tab': 'Вход по телефону',
  'pages.login.phoneLogin.errorMessage': 'Ошибка кода подтверждения',
  'pages.login.phoneNumber.placeholder': 'Номер телефона',
  'pages.login.phoneNumber.required': 'Пожалуйста, введите ваш номер телефона!',
  'pages.login.phoneNumber.invalid': 'Номер телефона недействителен!',
  'pages.login.captcha.placeholder': 'Код подтверждения',
  'pages.login.captcha.required': 'Пожалуйста, введите код подтверждения!',
  'pages.login.phoneLogin.getVerificationCode': 'Получить код',
  'pages.getCaptchaSecondText': 'сек',
  'pages.login.rememberMe': 'Запомнить меня',
  'pages.login.forgotPassword': 'Забыли пароль?',
  'pages.login.submit': 'Войти',
  'pages.login.loginWith': 'Войти через:',
  'pages.login.registerAccount': 'Регистрация аккаунта',
  'pages.welcome.link': 'Добро пожаловать',
  'pages.welcome.alertMessage':
    'Выпущены более быстрые и мощные компоненты для тяжелых задач.',
  'pages.404.subTitle': 'Извините, страница, которую вы посетили, не существует.',
  'pages.404.buttonText': 'Вернуться домой',
  'pages.admin.subPage.title': 'Эта страница может быть просмотрена только администратором',
  'pages.admin.subPage.alertMessage':
    'Umi ui теперь выпущен, добро пожаловать использовать npm run ui для начала работы.',
  'pages.searchTable.createForm.newRule': 'Новое правило',
  'pages.searchTable.updateForm.ruleConfig': 'Конфигурация правила',
  'pages.searchTable.updateForm.basicConfig': 'Основная информация',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Имя правила',
  'pages.searchTable.updateForm.ruleName.nameRules':
    'Пожалуйста, введите имя правила!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Описание правила',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder':
    'Пожалуйста, введите не менее пяти символов',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    'Пожалуйста, введите описание правила не менее чем из пяти символов!',
  'pages.searchTable.updateForm.ruleProps.title': 'Настроить свойства',
  'pages.searchTable.updateForm.object': 'Объект мониторинга',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'Шаблон правила',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'Тип правила',
  'pages.searchTable.updateForm.schedulingPeriod.title':
    'Установить период планирования',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Время начала',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules':
    'Пожалуйста, выберите время начала!',
  'pages.searchTable.titleDesc': 'Описание',
  'pages.searchTable.ruleName': 'Имя правила обязательно',
  'pages.searchTable.titleCallNo': 'Количество вызовов сервиса',
  'pages.searchTable.titleStatus': 'Статус',
  'pages.searchTable.nameStatus.default': 'по умолчанию',
  'pages.searchTable.nameStatus.running': 'работает',
  'pages.searchTable.nameStatus.online': 'онлайн',
  'pages.searchTable.nameStatus.abnormal': 'ненормально',
  'pages.searchTable.titleUpdatedAt': 'Последнее планирование в',
  'pages.searchTable.exception': 'Пожалуйста, введите причину исключения!',
  'pages.searchTable.titleOption': 'Опция',
  'pages.searchTable.config': 'Конфигурация',
  'pages.searchTable.subscribeAlert': 'Подписаться на уведомления',
  'pages.searchTable.title': 'Форма запроса',
  'pages.searchTable.new': 'Новый',
  'pages.searchTable.chosen': 'выбрано',
  'pages.searchTable.item': 'элемент',
  'pages.searchTable.totalServiceCalls': 'Общее количество вызовов сервиса',
  'pages.searchTable.tenThousand': '0000',
  'pages.searchTable.batchDeletion': 'пакетное удаление',
  'pages.searchTable.batchApproval': 'пакетное одобрение',
  
  // Agents page related text
  'pages.agents.search.placeholder': 'Поиск агентов',
  'pages.agents.create.button': 'Создать агента',
  'pages.agents.addDevice.button': 'Добавить устройство',
  'pages.agents.create.modal.title': 'Создать агента',
  'pages.agents.create.modal.nameLabel': 'Имя агента',
  'pages.agents.create.modal.placeholder': 'Пожалуйста, введите имя агента',
  'pages.agents.card.id': 'ID',
  'pages.agents.card.voiceModel': 'Голосовая модель',
  'pages.agents.card.languageModel': 'Языковая модель',
  'pages.agents.card.lastChat': 'Последний чат',
  'pages.agents.card.conversationId': 'ID разговора',
  'pages.agents.card.clearConversation': 'Очистить ID разговора',
  'pages.agents.card.clearConversation.success': 'ID разговора очищен',
  'pages.agents.card.clearConversation.error': 'Не удалось очистить ID разговора',
  'pages.agents.card.configRole': 'Настроить роль',
  'pages.agents.card.voiceRecognition': 'Распознавание голоса',
  'pages.agents.card.voiceRecognition.developing': 'Функция в разработке, ожидайте',
  'pages.agents.card.historyDialog': 'История диалогов',
  'pages.agents.card.manageDevice': 'Управление устройствами',
  'pages.agents.card.addDevice': 'Добавить устройство',
  'pages.agents.loading': 'Загрузка списка агентов...',
  'pages.agents.reload': 'Перезагрузить',
  'pages.agents.empty.title': 'Нет доступных агентов',
  'pages.agents.empty.createFirst': 'Создайте вашего первого агента',
  'pages.agents.delete.title': 'Подтвердить удаление агента',
  'pages.agents.delete.content': 'После удаления агента все связанные конфигурации (включая записи разговоров, связанные с устройством) не могут быть восстановлены. Вы уверены, что хотите удалить?',
  'pages.agents.delete.confirm': 'Подтвердить удаление',
  'pages.agents.fetch.error': 'Не удалось получить список агентов',
  'pages.agents.network.error': 'Сетевая ошибка, попробуйте позже',
  'pages.agents.speed.patient': 'Терпеливый',
  'pages.agents.speed.normal': 'Обычный',
  'pages.agents.speed.fast': 'Быстрый',
  'pages.agents.lastChat.none': 'Нет',
  'pages.agents.language.chinese': 'Китайский',
  'pages.agents.loading.tts.error': 'Не удалось загрузить голоса TTS',
  'pages.agents.loading.llm.error': 'Не удалось загрузить провайдеров LLM',
  'pages.agents.sort.id': 'Сортировать по ID',
  'pages.agents.sort.updatedAt': 'Сортировать по последнему изменению',
  'pages.agents.sort.lastConversationAt': 'Сортировать по последнему разговору',
  
  // Register page related text
  'pages.register': 'Регистрация',
  'pages.register.title': 'Регистрация',
  'pages.register.form.title': 'Зарегистрировать новый аккаунт',
  'pages.register.submit': 'Зарегистрироваться',
  'pages.register.username.placeholder': 'Пожалуйста, введите имя пользователя',
  'pages.register.username.required': 'Пожалуйста, введите имя пользователя!',
  'pages.register.username.min': 'Имя пользователя должно быть не менее 4 символов',
  'pages.register.email.placeholder': 'Пожалуйста, введите email',
  'pages.register.email.required': 'Пожалуйста, введите email!',
  'pages.register.email.invalid': 'Пожалуйста, введите действительный адрес email!',
  'pages.register.password.placeholder': 'Пожалуйста, введите пароль',
  'pages.register.password.required': 'Пожалуйста, введите пароль!',
  'pages.register.password.min': 'Пароль должен быть не менее 6 символов',
  'pages.register.password.pattern': 'Пароль должен содержать заглавные, строчные буквы и цифры',
  'pages.register.confirmPassword.placeholder': 'Пожалуйста, подтвердите пароль',
  'pages.register.confirmPassword.required': 'Пожалуйста, подтвердите пароль!',
  'pages.register.confirmPassword.min': 'Пароль должен быть не менее 6 символов',
  'pages.register.error.passwordMismatch': 'Два пароля не совпадают',
  'pages.register.error.registerFailed': 'Регистрация не удалась, попробуйте еще раз!',
  'pages.register.success': 'Регистрация успешна!',
  
  // Login page related text
  'pages.login.title': 'Консоль управления Anime AI Chat',
  'pages.login.actionIcons.notImplemented': 'Еще не реализовано, скоро будет',
  'pages.login.mobile.captchaError': 'Ошибка кода подтверждения',
  'pages.login.captcha.success': 'Код подтверждения отправлен успешно! Код: 1234',
  'pages.login.forgotPassword.contactAdmin': 'Пожалуйста, свяжитесь с администратором',
  'pages.login.mobile.notAvailable': 'Эта функция пока недоступна, используйте вход в аккаунт',
  
  // AgentSetting page related text
  'pages.agentSetting.title': 'Настроить роль',
  'pages.agentSetting.back': 'Назад',
  'pages.agentSetting.roleTemplate.title': 'Шаблон роли',
  'pages.agentSetting.roleTemplate.label': 'Шаблон',
  'pages.agentSetting.template.taiwanGirlfriend': 'Тайваньская подружка',
  'pages.agentSetting.template.potato': 'Картошка',
  'pages.agentSetting.template.englishTutor': 'Репетитор английского',
  'pages.agentSetting.template.curiousBoy': 'Любопытный мальчик',
  'pages.agentSetting.template.puppyLeader': 'Лидер щенков',
  'pages.agentSetting.basicConfig.title': 'Основная конфигурация',
  'pages.agentSetting.assistantName.label': 'Имя помощника',
  'pages.agentSetting.assistantName.placeholder': 'Пожалуйста, введите имя помощника',
  'pages.agentSetting.assistantName.required': 'Пожалуйста, введите имя помощника',
  'pages.agentSetting.dialogLanguage.label': 'Язык диалога',
  'pages.agentSetting.dialogLanguage.placeholder': 'Выберите язык диалога',
  'pages.agentSetting.voiceType.label': 'Тип голоса',
  'pages.agentSetting.voiceType.placeholder': 'Выберите тип голоса',
  'pages.agentSetting.roleDescription.title': 'Описание роли',
  'pages.agentSetting.roleDescription.label': 'Описание роли',
  'pages.agentSetting.roleDescription.placeholder': 'Пожалуйста, введите описание роли',
  'pages.agentSetting.roleDescription.required': 'Пожалуйста, введите описание роли',
  'pages.agentSetting.languageModel.title': 'Языковая модель',
  'pages.agentSetting.languageModel.label': 'Языковая модель',
  'pages.agentSetting.languageModel.placeholder': 'Выберите языковую модель',
  'pages.agentSetting.languageModel.tip': 'После изменения модели рекомендуется очистить память, чтобы избежать влияния на опыт чата.',
  'pages.agentSetting.advancedSettings.expand': 'Развернуть расширенные настройки',
  'pages.agentSetting.advancedSettings.collapse': 'Свернуть расширенные настройки',
  'pages.agentSetting.recognitionSpeed.label': 'Скорость распознавания речи',
  'pages.agentSetting.recognitionSpeed.placeholder': 'Выберите скорость распознавания',
  'pages.agentSetting.speechSpeed.label': 'Скорость речи',
  'pages.agentSetting.speechSpeed.placeholder': 'Выберите скорость речи',
  'pages.agentSetting.pitchValue.label': 'Громкость персонажа',
  'pages.agentSetting.button.reset': 'Сбросить',
  'pages.agentSetting.button.save': 'Сохранить',
  'pages.agentSetting.save.success': 'Сохранение успешно',
  'pages.agentSetting.save.error': 'Не удалось сохранить',
  'pages.agentSetting.save.missingId': 'Отсутствует ID агента, невозможно сохранить',
  'pages.agentSetting.load.tts.error': 'Не удалось загрузить голоса TTS',
  'pages.agentSetting.speed.slow': 'Медленно',
  'pages.agentSetting.speed.normal': 'Обычно',
  'pages.agentSetting.speed.fast': 'Быстро',
  'pages.agentSetting.speed.patient': 'Терпеливо',
  'pages.agentSetting.language.chinese': 'Китайский',
  'pages.agentSetting.language.english': 'Английский',
  'pages.agentSetting.language.spanish': 'Испанский',
  'pages.agentSetting.language.french': 'Французский',
  'pages.agentSetting.language.german': 'Немецкий',
  'pages.agentSetting.language.japanese': 'Японский',
  'pages.agentSetting.language.korean': 'Корейский',
  'pages.agentSetting.language.portuguese': 'Португальский',
  'pages.agentSetting.language.arabic': 'Арабский',
  'pages.agentSetting.language.russian': 'Русский',
  'pages.agentSetting.language.italian': 'Итальянский',
  'pages.agentSetting.language.turkish': 'Турецкий',
  'pages.agentSetting.language.polish': 'Польский',
  'pages.agentSetting.language.catalan': 'Каталанский',

  // DeviceManagement page related text
  'pages.devices.title': 'Управление устройствами',
  'pages.devices.breadcrumb.agents': 'Агенты',
  'pages.devices.breadcrumb.devices': 'Управление устройствами',
  'pages.devices.button.addDevice': 'Добавить устройство',
  'pages.devices.warning.noAgentId': 'Не указан agentId, невозможно получить список устройств',
  'pages.devices.device.unnamed': 'Неименованное устройство',
  'pages.devices.device.macAddress': 'MAC-адрес',
  'pages.devices.device.lastActive': 'Последняя активность',
  'pages.devices.device.firmwareVersion': 'Версия прошивки',
  'pages.devices.device.otaUpgrade': 'OTA обновление',
  'pages.devices.device.noData': 'Нет данных',
  'pages.devices.copy.success': 'MAC-адрес скопирован',
  'pages.devices.unbind.title': 'Подтвердить отвязку устройства',
  'pages.devices.unbind.content': 'Отвязку устройства нельзя отменить. Если вам нужно использовать его снова, вам нужно будет привязать его заново. Вы уверены, что хотите отвязать?',
  'pages.devices.unbind.confirm': 'Подтвердить отвязку',
  'pages.devices.unbind.cancel': 'Отмена',
  'pages.devices.unbind.success': 'Устройство отвязано',
  'pages.devices.unbind.error': 'Не удалось отвязать',
  'pages.devices.ota.enabled': 'OTA обновление включено',
  'pages.devices.ota.disabled': 'OTA обновление отключено',
  
  // HistoryDialogs page related text
  'pages.historyDialogs.title': 'История диалогов',
  'pages.historyDialogs.breadcrumb.agents': 'Агенты',
  'pages.historyDialogs.breadcrumb.historyDialogs': 'История диалогов',
  'pages.historyDialogs.empty.title': 'Разговор не выбран',
  'pages.historyDialogs.empty.description': 'Пожалуйста, выберите разговор',
  'pages.historyDialogs.agent': 'Агент',
  'pages.historyDialogs.agent.id': 'id',
  'pages.historyDialogs.conversationDetail': 'Детали разговора',
  'pages.historyDialogs.selectConversation': 'Пожалуйста, выберите разговор',
  'pages.historyDialogs.delete.title': 'Удалить разговор',
  'pages.historyDialogs.delete.content': 'Разговор нельзя восстановить после удаления. Пожалуйста, подтвердите операцию.',
  'pages.historyDialogs.delete.confirm': 'Подтвердить',
  'pages.historyDialogs.delete.cancel': 'Отмена',
  'pages.historyDialogs.message.delete.confirm': 'Вы уверены, что хотите удалить это сообщение? Его нельзя будет восстановить после удаления.',
  'pages.historyDialogs.detail.title': 'Детали разговора',
  'pages.historyDialogs.agent.label': 'Агент:',
  'pages.historyDialogs.user.label': 'Пользователь:',
  'pages.historyDialogs.loading': 'Загрузка...',
  'pages.historyDialogs.error.loadFailed': 'Не удалось загрузить список разговоров',
  'pages.historyDialogs.error.deleteFailed': 'Не удалось удалить разговор',
  'pages.historyDialogs.success.deleteSuccess': 'Разговор успешно удален',
  
  // MessageList page related text
  'pages.messageList.empty': 'Нет сообщений',
  'pages.messageList.user': 'Пользователь',
  'pages.messageList.ai': 'ИИ',
  
  // Settings page related text
  'pages.settings.basicInfo.title': 'Основная информация',
  'pages.settings.avatar.label': 'Аватар:',
  'pages.settings.avatar.change': 'Изменить аватар',
  'pages.settings.avatar.updateSuccess': 'Аватар успешно обновлен',
  'pages.settings.avatar.updateFailed': 'Не удалось обновить аватар',
  'pages.settings.username.label': 'Имя пользователя:',
  'pages.settings.nickname.label': 'Псевдоним:',
  'pages.settings.nickname.change': 'Редактировать псевдоним',
  'pages.settings.nickname.modal.title': 'Редактировать псевдоним',
  'pages.settings.nickname.form.label': 'Новый псевдоним',
  'pages.settings.nickname.form.required': 'Пожалуйста, введите новый псевдоним',
  'pages.settings.nickname.form.length': 'Длина псевдонима должна быть 2-20 символов',
  'pages.settings.nickname.updateSuccess': 'Псевдоним успешно обновлен',
  'pages.settings.nickname.updateFailed': 'Не удалось обновить псевдоним',
  'pages.settings.registerTime.label': 'Время регистрации:',
  'pages.settings.email.label': 'Email:',
  'pages.settings.email.unbind': 'Не привязан',
  'pages.settings.email.bind': 'Привязать Email',
  'pages.settings.email.change': 'Изменить Email',
  'pages.settings.email.modal.title': 'Привязать Email',
  'pages.settings.email.modal.changeTitle': 'Изменить Email',
  'pages.settings.email.form.label': 'Email',
  'pages.settings.email.form.required': 'Пожалуйста, введите email',
  'pages.settings.email.form.invalid': 'Неверный формат email',
  'pages.settings.email.bindSuccess': 'Email успешно привязан',
  'pages.settings.email.bindFailed': 'Не удалось привязать email',
  'pages.settings.changePassword.title': 'Изменить пароль',
  'pages.settings.changePassword.button': 'Изменить пароль',
  'pages.settings.changePassword.modal.title': 'Изменить пароль',
  'pages.settings.changePassword.oldPassword.label': 'Старый пароль',
  'pages.settings.changePassword.oldPassword.required': 'Пожалуйста, введите старый пароль',
  'pages.settings.changePassword.newPassword.label': 'Новый пароль',
  'pages.settings.changePassword.newPassword.required': 'Пожалуйста, введите новый пароль',
  'pages.settings.changePassword.newPassword.min': 'Новый пароль должен быть не менее 6 символов',
  'pages.settings.changePassword.confirmPassword.label': 'Подтвердите новый пароль',
  'pages.settings.changePassword.confirmPassword.required': 'Пожалуйста, подтвердите новый пароль',
  'pages.settings.changePassword.confirmPassword.mismatch': 'Пароли не совпадают',
  'pages.settings.changePassword.success': 'Пароль успешно изменен',
  'pages.settings.changePassword.failed': 'Не удалось изменить пароль',
  'pages.settings.deleteAccount.title': 'Удалить аккаунт',
  'pages.settings.deleteAccount.button': 'Удалить аккаунт',
  'pages.settings.deleteAccount.confirm.title': 'Подтвердить удаление аккаунта?',
  'pages.settings.deleteAccount.confirm.content': 'Эта операция не может быть отменена. Вы уверены, что хотите удалить свой аккаунт?',
  'pages.settings.deleteAccount.confirm.ok': 'Удалить',
  'pages.settings.deleteAccount.confirm.cancel': 'Отмена',
  'pages.settings.deleteAccount.success': 'Аккаунт успешно удален',
  'pages.settings.deleteAccount.failed': 'Не удалось удалить аккаунт',
  'pages.settings.profile.fetchFailed': 'Не удалось получить информацию о пользователе',
  'pages.settings.form.submit': 'Отправить',
  'pages.settings.password.title': 'Настройки пароля',
  'pages.settings.basicInfo.username': 'Имя пользователя',
  'pages.settings.basicInfo.nickname': 'Псевдоним',
  'pages.settings.basicInfo.avatar': 'Аватар',
  'pages.settings.basicInfo.editNickname': 'Редактировать псевдоним',
  'pages.settings.basicInfo.editNicknameTitle': 'Редактировать псевдоним',
  'pages.settings.basicInfo.newNicknameLabel': 'Новый псевдоним',
  'pages.settings.basicInfo.nicknameChangeSuccess': 'Псевдоним успешно изменен',
  'pages.settings.basicInfo.openId': 'OpenID:',
  'pages.settings.submit': 'Отправить',
  'pages.settings.deleteAccount.confirmTitle': 'Подтвердить удаление аккаунта',
  'pages.settings.deleteAccount.confirmContent': 'После удаления вашего аккаунта все ваши данные будут безвозвратно удалены и не могут быть восстановлены, и вы больше не сможете войти в систему с этим аккаунтом. Пожалуйста, действуйте осторожно!',
  'pages.settings.deleteAccount.cancel': 'Отмена',
  'pages.settings.deleteAccount.confirm': 'Подтвердить удаление',
  
  // Admin Dashboard
  'pages.admin.dashboard.userCount': 'Количество пользователей',
  'pages.admin.dashboard.deviceCount': 'Количество устройств', 
  'pages.admin.dashboard.agentCount': 'Количество агентов',
  'pages.admin.dashboard.onlineUsers': 'Пользователи онлайн',
  'pages.admin.dashboard.sessionDevices': 'Устройства сессии',
  'pages.admin.dashboard.memoryUsage': 'Использование памяти',
  'pages.admin.dashboard.cpuUsage': 'Использование CPU',
  'pages.admin.dashboard.fetchError': 'Не удалось получить данные',
  'pages.admin.dashboard.networkError': 'Сетевая ошибка',

  // Admin User Management
  'pages.admin.user.id': 'ID',
  'pages.admin.user.username': 'Имя пользователя',
  'pages.admin.user.email': 'Email',
  'pages.admin.user.status': 'Статус',
  'pages.admin.user.status.all': 'Все',
  'pages.admin.user.status.disabled': 'Отключено',
  'pages.admin.user.status.normal': 'Обычный',
  'pages.admin.user.quotaUsed': 'Дневная квота использована',
  'pages.admin.user.quotaTotal': 'Общая дневная квота',
  'pages.admin.user.createdAt': 'Создано в',
  'pages.admin.user.operations': 'Операции',
  'pages.admin.user.edit': 'Редактировать',
  'pages.admin.user.detail': 'Детали',
  'pages.admin.user.editModal.title': 'Редактировать пользователя',
  'pages.admin.user.status.label': 'Статус пользователя',
  'pages.admin.user.status.enable': 'Включить',
  'pages.admin.user.status.disable': 'Отключить',
  'pages.admin.user.quotaUsed.label': 'Дневная квота использована',
  'pages.admin.user.quotaTotal.label': 'Общая дневная квота',
  'pages.admin.user.email.label': 'Email',
  'pages.admin.user.save.success': 'Сохранение успешно',
  'pages.admin.user.save.failed': 'Не удалось сохранить',
  'pages.admin.user.list.title': 'Список пользователей',

  // Admin Model Providers
  'pages.admin.providers.title': 'Управление поставщиками моделей',
  'pages.admin.providers.total': 'Всего {total} поставщиков',
  'pages.admin.providers.stats': 'ASR: {asr}, TTS: {tts}, LLM: {llm}, VLLLM: {vlllm}',
  'pages.admin.providers.addNew': 'Добавить нового поставщика',
  'pages.admin.providers.search.placeholder': 'Поиск имени поставщика, конечной точки или модели...',
  'pages.admin.providers.filter.all': 'Все типы',
  'pages.admin.providers.filter.asr': 'ASR - Распознавание речи',
  'pages.admin.providers.filter.tts': 'TTS - Преобразование текста в речь', 
  'pages.admin.providers.filter.llm': 'LLM - Большая языковая модель',
  'pages.admin.providers.filter.vlllm': 'VLLLM - Модель языка зрения',
  'pages.admin.providers.empty.noProviders': 'Поставщиков пока нет',
  'pages.admin.providers.empty.noMatches': 'Подходящих поставщиков не найдено',
  'pages.admin.providers.empty.addFirst': 'Нажмите кнопку выше, чтобы добавить вашего первого поставщика модели',
  'pages.admin.providers.empty.adjustFilters': 'Попробуйте настроить критерии поиска или фильтры',
  'pages.admin.providers.type.asr': 'ASR - Распознавание речи',
  'pages.admin.providers.type.tts': 'TTS - Преобразование текста в речь',
  'pages.admin.providers.type.llm': 'LLM - Большая языковая модель',
  'pages.admin.providers.type.vlllm': 'VLLLM - Модель языка зрения',
  'pages.admin.providers.success.created': 'Поставщик успешно добавлен!',
  'pages.admin.providers.success.updated': 'Поставщик успешно обновлен!',
  'pages.admin.providers.success.deleted': 'Поставщик успешно удален!',
  'pages.admin.providers.success.statusToggled': 'Статус успешно переключен!',
  'pages.admin.providers.error.createFailed': 'Не удалось добавить поставщика, попробуйте еще раз',
  'pages.admin.providers.error.updateFailed': 'Не удалось обновить поставщика, попробуйте еще раз',
  'pages.admin.providers.error.deleteFailed': 'Не удалось удалить поставщика, попробуйте еще раз',
  'pages.admin.providers.error.testFailed': 'Тест соединения не удался, проверьте сеть или конфигурацию',
  'pages.admin.providers.error.toggleFailed': 'Не удалось переключить статус, попробуйте еще раз',
  'pages.admin.providers.error.loadFailed': 'Не удалось загрузить список поставщиков, обновите страницу',

  // Admin Settings
  'pages.admin.settings.title': 'Системные настройки',
  'pages.admin.settings.asr.label': 'Сервис ASR',
  'pages.admin.settings.asr.placeholder': 'Выбрать сервис ASR',
  'pages.admin.settings.tts.label': 'Сервис TTS',
  'pages.admin.settings.tts.placeholder': 'Выбрать сервис TTS',
  'pages.admin.settings.llm.label': 'Сервис LLM',
  'pages.admin.settings.llm.placeholder': 'Выбрать сервис LLM',
  'pages.admin.settings.vlllm.label': 'Сервис VLLLM',
  'pages.admin.settings.vlllm.placeholder': 'Выбрать сервис VLLLM',
  'pages.admin.settings.prompt.label': 'Настройки промпта',
  'pages.admin.settings.prompt.placeholder': 'Пожалуйста, введите системный промпт...',
  'pages.admin.settings.quickReply.label': 'Слова быстрого ответа',
  'pages.admin.settings.quickReply.placeholder': 'Введите новое слово быстрого ответа',
  'pages.admin.settings.quickReply.add': 'Добавить',
  'pages.admin.settings.deleteAudio.label': 'Удалить аудио',
  'pages.admin.settings.deleteAudio.enabled': 'Включено',
  'pages.admin.settings.deleteAudio.disabled': 'Отключено',
  'pages.admin.settings.usePrivateConfig': 'Использовать приватную конфигурацию',
  'pages.admin.settings.save': 'Сохранить конфигурацию',
  'pages.admin.settings.saving': 'Сохранение...',
  'pages.admin.settings.reset': 'Сброс',
  'pages.admin.settings.success.saved': 'Конфигурация успешно сохранена!',
  'pages.admin.settings.error.saveFailed': 'Не удалось сохранить конфигурацию, попробуйте еще раз',
  'pages.admin.settings.error.loadFailed': 'Не удалось загрузить конфигурацию, обновите страницу и попробуйте еще раз',


  // Add Device Dialog
  'pages.addDevice.modal.title': 'Добавить устройство',
  'pages.addDevice.verificationCode.label': 'Код подтверждения:',
  'pages.addDevice.verificationCode.placeholder': 'Пожалуйста, введите 6-значный код подтверждения с устройства',
  'pages.addDevice.verificationCode.required': 'Пожалуйста, введите 6-значный код подтверждения',
  'pages.addDevice.verificationCode.error': 'Пожалуйста, введите 6-значный код подтверждения',

  // Provider Modal
  'pages.admin.providerModal.edit.title': 'Редактировать поставщика',
  'pages.admin.providerModal.add.title': 'Добавить нового поставщика',
  'pages.admin.providerModal.name.label': 'Имя поставщика *',
  'pages.admin.providerModal.name.placeholder': 'например: OpenAI, Doubao TTS',
  'pages.admin.providerModal.name.required': 'Пожалуйста, введите имя поставщика',
  'pages.admin.providerModal.type.label': 'Категория сервиса *',
  'pages.admin.providerModal.subType.label': 'Конкретный тип *',
  'pages.admin.providerModal.subType.required': 'Пожалуйста, выберите конкретный тип',
  'pages.admin.providerModal.config.title': 'Конфигурация',
  'pages.admin.providerModal.api.url.label': 'URL API *',
  'pages.admin.providerModal.api.url.required': 'Пожалуйста, введите URL API',
  'pages.admin.providerModal.model.name.label': 'Имя модели *',
  'pages.admin.providerModal.model.name.required': 'Пожалуйста, введите имя модели',
  'pages.admin.providerModal.api.key.label': 'Ключ API *',
  'pages.admin.providerModal.api.key.required': 'Пожалуйста, введите ключ API',
  'pages.admin.providerModal.temperature.label': 'Температура (0-2)',
  'pages.admin.providerModal.temperature.error': 'Температура должна быть между 0-2',
  'pages.admin.providerModal.maxTokens.label': 'Максимум токенов',
  'pages.admin.providerModal.maxTokens.error': 'Максимум токенов должно быть между 1-32768',
  'pages.admin.providerModal.topP.label': 'Top-P',
  'pages.admin.providerModal.appid.label': 'ID приложения *',
  'pages.admin.providerModal.appid.required': 'Пожалуйста, введите ID приложения',
  'pages.admin.providerModal.accessToken.label': 'Токен доступа *',
  'pages.admin.providerModal.accessToken.required': 'Пожалуйста, введите токен доступа',
  'pages.admin.providerModal.cluster.label': 'Кластер',
  'pages.admin.providerModal.grpc.host.label': 'Хост gRPC *',
  'pages.admin.providerModal.grpc.host.required': 'Пожалуйста, введите адрес хоста gRPC',
  'pages.admin.providerModal.grpc.port.label': 'Порт gRPC *',
  'pages.admin.providerModal.grpc.port.required': 'Пожалуйста, введите порт gRPC',
  'pages.admin.providerModal.voice.label': 'Голос *',
  'pages.admin.providerModal.voice.required': 'Пожалуйста, введите тип голоса',
  'pages.admin.providerModal.token.label': 'Токен *',
  'pages.admin.providerModal.token.required': 'Пожалуйста, введите токен',
  'pages.admin.providerModal.websocket.label': 'URL WebSocket *',
  'pages.admin.providerModal.websocket.required': 'Пожалуйста, введите URL WebSocket',
  'pages.admin.providerModal.siliconflow.apiKey.label': 'Ключ API *',
  'pages.admin.providerModal.siliconflow.apiKey.required': 'Пожалуйста, введите ключ API',
  'pages.admin.providerModal.siliconflow.baseUrl.label': 'URL API',
  'pages.admin.providerModal.manage.voices': 'Управление голосами',
  'pages.admin.providerModal.edge.noConfig': 'Microsoft Edge TTS не требует дополнительной конфигурации',
  'pages.admin.providerModal.submit.error': 'Отправка не удалась, попробуйте еще раз',

  // Provider Card
  'pages.admin.providerCard.status.active': 'Активный',
  'pages.admin.providerCard.status.inactive': 'Офлайн',
  'pages.admin.providerCard.status.error': 'Ошибка',
  'pages.admin.providerCard.status.unknown': 'Неизвестно',
  'pages.admin.providerCard.warning.readonly.test': 'Права только для чтения, невозможно протестировать поставщика',
  'pages.admin.providerCard.warning.readonly.delete': 'Права только для чтения, невозможно удалить поставщика',
  'pages.admin.providerCard.warning.readonly.edit': 'Права только для чтения, невозможно редактировать поставщика',
  'pages.admin.providerCard.warning.readonly.toggle': 'Права только для чтения, невозможно переключить статус',
  'pages.admin.providerCard.button.disable': 'Отключить',
  'pages.admin.providerCard.button.enable': 'Включить',
  'pages.admin.providerCard.button.testing': 'Тестирование...',
  'pages.admin.providerCard.button.test': 'Тест',
  'pages.admin.providerCard.button.edit': 'Редактировать',
  'pages.admin.providerCard.button.delete': 'Удалить',
  'pages.admin.providerCard.delete.title': 'Вы уверены, что хотите удалить этот элемент?',
  'pages.admin.providerCard.delete.content': 'Его нельзя восстановить после удаления, подтвердите операцию.',
  'pages.admin.providerCard.config.type': 'Тип',
  'pages.admin.providerCard.config.apiUrl': 'URL API',
  'pages.admin.providerCard.config.model': 'Модель',
  'pages.admin.providerCard.config.apiKey': 'Ключ API',
  'pages.admin.providerCard.config.temperature': 'Температура',
  'pages.admin.providerCard.config.maxTokens': 'Максимум токенов',
  'pages.admin.providerCard.config.appid': 'ID приложения',
  'pages.admin.providerCard.config.cluster': 'Кластер',
  'pages.admin.providerCard.config.accessToken': 'Токен доступа',
  'pages.admin.providerCard.config.grpcHost': 'Хост gRPC',
  'pages.admin.providerCard.config.grpcPort': 'Порт gRPC',
  'pages.admin.providerCard.config.voice': 'Голос',
  'pages.admin.providerCard.config.format': 'Формат',
  'pages.admin.providerCard.config.token': 'Токен',
  'pages.admin.providerCard.config.outputDir': 'Выходная директория',
  'pages.admin.providerCard.voices.supported': 'Поддерживаемые голоса',
  'pages.admin.providerCard.voices.count': '',
  'pages.admin.providerCard.test.failed': 'Тест не удался',

    // OpsManage
  'pages.admin.ops.service.title': 'Управление сервисами',
  'pages.admin.ops.upload.button': 'Загрузить файл сервиса',
  'pages.admin.ops.upload.success': 'Файл сервиса успешно загружен',
  'pages.admin.ops.upload.error': 'Не удалось загрузить файл сервиса',
  'pages.admin.ops.restart.button': 'Перезапустить сервис',
  'pages.admin.ops.restart.confirmTitle': 'Внимание: Вы уверены, что хотите перезапустить сервис?',
  'pages.admin.ops.restart.desc': 'Перезапуск сервиса отключит все текущие соединения и сделает сервис временно недоступным.',
  'pages.admin.ops.restart.warn': 'Эта операция только остановит текущий процесс сервиса. Пожалуйста, убедитесь, что на сервере настроен демон или скрипт автоперезапуска, иначе сервис не восстановится автоматически!',
  'pages.admin.ops.restart.ok': 'Подтвердить перезапуск',
  'pages.admin.ops.restart.cancel': 'Отмена',
  'pages.admin.ops.restart.success': 'Команда перезапуска сервиса отправлена',
  'pages.admin.ops.restart.error': 'Не удалось перезапустить сервис',
  'pages.admin.ops.log.title': 'Просмотр и загрузка логов',
  'pages.admin.ops.web.upload.button': 'Загрузить web.zip',
  'pages.admin.ops.web.upload.success': 'web.zip успешно загружен',
  'pages.admin.ops.web.upload.error': 'Не удалось загрузить web.zip',
  'pages.admin.ops.web.upload.onlyzip': 'Разрешены только zip файлы',
  'pages.admin.ops.web.update.button': 'Обновить web директорию',
  'pages.admin.ops.web.update.success': 'Команда обновления web директории отправлена',
  'pages.admin.ops.web.update.error': 'Не удалось обновить web директорию',
  'pages.admin.ops.web.upload.onlywebzip': 'Разрешен только файл с именем web.zip',

  // Recorder Management
  'pages.admin.recorder.title': 'Управление записывающими устройствами',
  'pages.admin.recorder.inputDeviceId': 'Пожалуйста, введите ID устройства',
  'pages.admin.recorder.inputPlaceholder': 'Пожалуйста, введите ID устройства',
  'pages.admin.recorder.search': 'Поиск',
  'pages.admin.recorder.list.title': 'Список записывающих устройств',
  'pages.admin.recorder.fetchSuccess': 'Записи записывающих устройств успешно получены',
  'pages.admin.recorder.fetchError': 'Не удалось получить список записывающих устройств',
  'pages.admin.recorder.empty': 'Нет данных записывающих устройств, введите ID устройства для поиска',
  'pages.admin.recorder.totalCount': 'Статистика',
  'pages.admin.recorder.conversationId': 'ID разговора',

  'pages.agentSetting.mcp.modal.title': 'Настройки конечной точки MCP',
  'pages.agentSetting.mcp.modal.statusLabel': 'Статус конечной точки',
  'pages.agentSetting.mcp.modal.online': 'Онлайн',
  'pages.agentSetting.mcp.modal.disconnected': 'Отключен',
  'pages.agentSetting.mcp.modal.unknown': 'Неизвестно',
  'pages.agentSetting.mcp.modal.refresh': 'Обновить',
  'pages.agentSetting.mcp.modal.enabledServices': 'Включенные сервисы',
  'pages.agentSetting.mcp.modal.endpointLabel': 'Адрес конечной точки',
  'pages.agentSetting.mcp.modal.endpointDesc': 'Ниже указан адрес конечной точки MCP агента.',
  'pages.agentSetting.mcp.modal.docLink': 'Просмотреть документацию по конечной точке',
  'pages.agentSetting.mcp.modal.noEndpoint': 'Нет доступных конечных точек',
  'pages.agentSetting.mcp.modal.hide': 'Скрыть',
  'pages.agentSetting.mcp.title': 'Настройки MCP', 
  'pages.agentSetting.mcp.customService': 'Пользовательский сервис',
  'pages.agentSetting.mcp.officialServices': 'Официальные сервисы',
  'pages.agentSetting.mcp.officialServices.placeholder': 'Выберите официальные сервисы',
  'pages.agentSetting.mcp.services.weather': 'Погода',
  'pages.agentSetting.mcp.services.joke': 'Шутка',
  'pages.agentSetting.mcp.services.music': 'Музыка',
  'pages.agentSetting.mcp.services.news': 'Новости',
  'pages.agentSetting.mcp.error.missingId': 'Отсутствует ID агента, не удалось получить конечную точку',
  'pages.agentSetting.mcp.error.noEndpoint': 'Не удалось получить конечную точку от сервера',
'pages.agentSetting.mcp.error.fetchFailed': 'Не удалось получить конечную точку',
  'pages.agentSetting.mcp.button.getEndpoint': 'Получить конечную точку MCP',

  // Memory settings
  'pages.agentSetting.memory.title': 'Краткосрочная память',
  'pages.agentSetting.memory.type.label': 'Тип памяти',
  'pages.agentSetting.memory.type.none': 'Без памяти',
  'pages.agentSetting.memory.type.shortTerm': 'Краткосрочная память',
  'pages.agentSetting.memory.current.label.short': 'Текущая память',
  'pages.agentSetting.memory.current.help': 'Обновляется после каждого диалога',
  'pages.agentSetting.memory.clear': 'Очистить память',
  'pages.agentSetting.memory.clear.tip': 'Память отмечена для очистки, нажмите сохранить для применения',
  'pages.agentSetting.memory.content.label': 'Содержимое памяти',
  'pages.agentSetting.memory.content.placeholder': 'Получить последнее содержимое краткосрочной памяти агента',
  'pages.agentSetting.memory.content.editPlaceholder': 'Пожалуйста, введите содержимое памяти',
  'pages.agentSetting.memory.edit': 'Редактировать память',
  'pages.agentSetting.memory.edit.success': 'Память обновлена, пожалуйста, сохраните для применения',
  'pages.agentSetting.memory.edit.save': 'Сохранить изменения',
  'pages.agentSetting.memory.edit.cancel': 'Отмена',

  // Общие кнопки и операции
  'pages.common.cancel': 'Отмена',

  // Конфигурация системы
  'pages.admin.systemConfig.roleName': 'Название роли',
  'pages.admin.systemConfig.roleDesc': 'Описание роли',
  'pages.admin.systemConfig.enabled': 'Состояние включения',
  'pages.admin.systemConfig.featureName': 'Название функции',
  'pages.admin.systemConfig.featureDesc': 'Описание функции',
  'pages.admin.systemConfig.exitCommand': 'Команда выхода',
  'pages.admin.systemConfig.mcpName': 'Название MCP',
  'pages.admin.systemConfig.newNameOptional': 'Новое название (необязательно)',
  'pages.admin.systemConfig.configJson': 'Конфигурация JSON',
  'pages.admin.systemConfig.useDeviceCode': 'Использовать код устройства',
  'pages.admin.systemConfig.quickReply': 'Быстрый ответ',
  'pages.admin.systemConfig.shortTermMemory': 'Короткая память',
  'pages.admin.systemConfig.saveUserAudio': 'Сохранять аудиофайлы пользователя',
  'pages.admin.systemConfig.enableWhiteList': 'Включить белый список',
  'pages.admin.systemConfig.speakerDetect': 'Распознавание говорящего',
  'pages.admin.systemConfig.recorderManagerEnable': 'Включить управление рекордером',
  'pages.admin.systemConfig.voiceCloneEnable': 'Включить клонирование голоса',
  'pages.admin.systemConfig.flattenedChatHistory': 'Упрощенная история чата',
  'pages.admin.systemConfig.dialogueHistoryLength': 'Длина истории диалога',
  'pages.admin.systemConfig.userTotalQuota': 'Общий лимит пользователя',
  'pages.admin.systemConfig.dailyClearQuota': 'Ежедневная очистка квоты',
  'pages.admin.systemConfig.checkDeviceModeImmediately': 'Немедленно проверить режим устройства',
  'pages.admin.systemConfig.defaultObserverUserOnRegister': 'Роль наблюдателя по умолчанию для новых пользователей',
  'pages.admin.systemConfig.status': 'Состояние',
  'pages.admin.systemConfig.port': 'Порт',
  'pages.admin.systemConfig.udpShowPort': 'Показать порт',
  'pages.admin.systemConfig.accessToken': 'Токен доступа',
  'pages.admin.systemConfig.activateText': 'Текст активации',
  'pages.admin.systemConfig.logLevel': 'Уровень логирования',
  'pages.admin.systemConfig.logDir': 'Директория журнала',
  'pages.admin.systemConfig.logFileName': 'Имя файла журнала',

  // Клонирование голоса
  'pages.console.voiceClone.name': 'Имя',
  'pages.console.voiceClone.provider': 'Поставщик',
  'pages.console.voiceClone.mode': 'Режим',
  'pages.console.voiceClone.record': 'Записать',
  'pages.console.voiceClone.upload': 'Загрузить',

  // Распознавание говорящего
  'pages.console.speakers.name': 'Имя',
  'pages.console.speakers.mode': 'Режим',
  'pages.console.speakers.record': 'Записать',
  'pages.console.speakers.upload': 'Загрузить',

  // Настройки страницы
  'pages.console.settings.email': 'Электронная почта',
  'pages.console.settings.oldPassword': 'Старый пароль',
  'pages.console.settings.newPassword': 'Новый пароль',
  'pages.console.settings.confirmNewPassword': 'Подтвердить новый пароль',

  // Поставщик VLLM
  'pages.providers.vllm.maxPixels': 'Максимальное количество пикселей',
  'pages.admin.providerModal.copyAsNew': 'Копировать как нового поставщика',

  'pages.unbindDevice.cardTitle': 'Отвязка устройства',
  'pages.whiteList.cardTitle': 'Управление белым списком',
  'pages.admin.ops.logViewer.previewTitle': 'Предпросмотр журнала',
  'pages.admin.ops.logViewer.fileName': 'Имя файла:',
  'pages.admin.ops.logViewer.lineCount': 'Количество строк:',
  'pages.admin.ops.logViewer.previewBtn': 'Предпросмотр',
  'pages.admin.ops.logViewer.noContent': 'Нет содержимого',
  'pages.admin.devices': 'Управление устройствами',
  'pages.admin.unbindDevice': 'Отвязка устройства',
  'pages.admin.deviceManage': 'Управление устройствами',
  'pages.systemConfig.quickReply': 'Быстрый ответ',
  'pages.systemConfig.useShortTermMemory': 'Кратковременная память',
  'pages.systemConfig.useShortTermMemory.desc': 'При включении система использует механизм кратковременной памяти и обновляет её после каждого раунда диалога. При выключении кратковременная память не используется.',
  'pages.agentSetting.mcp.modal.show': 'Показать',
  'pages.agentSetting.mcp.modal.copied': 'Скопировано',
  'pages.agentSetting.mcp.modal.copy': 'Копировать',
  'pages.admin.providerModal.model.label': 'Модель *',
  'pages.admin.providerModal.model.placeholder': 'Введите название модели',
  'pages.admin.providerModal.model.required': 'Введите название модели',
  'pages.admin.providerModal.security.title': 'Настройки безопасности',
  'pages.admin.providerModal.appid.placeholder': 'ID приложения Doubao',
  'pages.admin.providerModal.accessToken.placeholder': 'Токен доступа',
  'pages.admin.providerModal.grpc.addr.label': 'Адрес gRPC (Хост:Порта) *',
  'pages.admin.providerModal.grpc.addr.required': 'Введите адрес gRPC (Хост:Порта)',
  'pages.admin.providerModal.token.placeholder': 'Токен Doubao',
  'pages.admin.providerModal.siliconflow.apiKey.placeholder': 'API-ключ',
  'pages.admin.providerModal.manageVoices': 'Управление голосами',
  'pages.admin.whiteList.inputMac': 'Введите MAC-адрес',
  'pages.admin.whiteList.batchAdd': 'Добавить批量',
  'pages.admin.whiteList.add': 'Добавить',
  'pages.admin.whiteList.list.title': 'Список MAC-адресов',
  'pages.admin.whiteList.selectCsvTip': 'Выберите CSV-файл',
  'pages.admin.whiteList.uploadSuccess': 'Загрузка успешна',
  'pages.admin.whiteList.uploadFailed': 'Ошибка загрузки',
  'pages.admin.whiteList.invalidMac': 'Введите корректный MAC-адрес',
  'pages.admin.settings.voiceCloneEnable': 'Включить клонирование голоса',
  'pages.agentSetting.roleTemplate.empty': 'Шаблоны недоступны. Проверьте role_template.json',
  'pages.admin.providerModal.save': 'Сохранить',
  'pages.contractDevice.cardTitle': 'Управление контрактными устройствами',
  'pages.contractDevice.mac': 'MAC-адрес',
  'pages.contractDevice.protocolType': 'Тип протокола',
  'pages.contractDevice.status': 'Статус',
  'pages.contractDevice.expireTime': 'Срок действия',
  'pages.contractDevice.updateTime': 'Время обновления',
  'pages.contractDevice.operations': 'Операции',
  'pages.contractDevice.edit': 'Редактировать',
  'pages.contractDevice.delete': 'Удалить',
  'pages.contractDevice.deleteConfirm': 'Подтвердить удаление',
  'pages.contractDevice.addTitle': 'Добавить контрактное устройство',
  'pages.contractDevice.batchAddTitle': 'Добавить批量',
  'pages.contractDevice.editTitle': 'Редактировать контрактное устройство',
  'pages.contractDevice.listTitle': 'Список контрактных устройств',
  'pages.contractDevice.add': 'Добавить',
  'pages.contractDevice.batchAdd': 'Добавить批量',
  'pages.contractDevice.selectCsvTip': 'Выберите CSV-файл',
  'pages.contractDevice.uploadSuccess': 'Загрузка успешна',
  'pages.contractDevice.macRequired': 'Введите MAC-адрес',
  'pages.contractDevice.protocolTypeRequired': 'Выберите тип протокола',
  'pages.contractDevice.statusRequired': 'Выберите статус',
  'pages.contractDevice.expireTimeRequired': 'Выберите срок действия',
};